<template>
  <div>
    <super-base-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :linkGoalInfo="linkGoalInfo"
      :selectedComponent="superSelectedComponent"
      :chartTabContent="superChartTabContentData"
      :leftToolSummary="[]"
      :isShowDownloadIcon="true"
      :chartProperties="chartProperties"
      :chartData="chartGraphData"
      :linePlotData="linePlotData"
      :isShowEmptyState="isShowEmptyState"
      :emptyChartMessage="emptyChartMessage"
      :rightToolSummary="superRightToolSummary"
      :formModel="formModel"
      :formSubmitElements="formSubmitElements"
      :downloadOption="reportDownloadOption"
      downloadLabelName="Report"
      :projectionYear="projectionYear"
      :expandableCardData="ExpandableCardData"
      @downloadExcelFile="downloadReport"
      @changeSuperProjectionYear="changeProjectionYear"
      @formChange="formChange"
      @dropDownChange="genericMethodClick"
      @onSubmit="genericMethodClick"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @onChangeChartTab="onChangeSuperChartTab"
      @ChangeExpandableCard="ChangeExpandableCard"
      @EditCard="editExpandablecard"
      @EditDataList="EditDataList"
      @refresh="refresh"
      :showTableView="showTableView"
      :tableViewSettings="tableViewSettings"
      :buttonDataTypeConfig="buttonDataTypeConfig"
      :buttonViewTypeConfig="buttonViewTypeConfig"
      @onSelectDataTypeFilter="onSelectDataTypeFilter"
      @onSelectViewTypeFilter="onSelectViewTypeFilter"
    >
      <template v-slot:expandableformdata>
        <adl-data-list
          v-if="
            formslotElement.options != null &&
            formslotElement.options.length > 0
          "
          :headingtext="formslotElement.name"
          :listdata="formslotElement.options"
          :editbuttonvisible="true"
          @OnEdit="EditDataList"
        >
        </adl-data-list>
      </template>
      <template v-slot:tooltipText>
        <mds-table>
          <mds-tr v-for="(data, i) in sgcValues" :key="i">
            <mds-td> {{ data }} </mds-td>
          </mds-tr>
        </mds-table>
      </template>
    </super-base-engagement-tool>

    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    ></confirmation-dialog>
    <component
      :is="selectedComponent"
      :key="editSuperKey"
      :isopenModel="isopenModel"
      :baselineData="baselineData"
      :openTabName="openTabName"
      :selectedMenuId="menuId"
      :subMenuId="subMenuId"
      @closeModel="closeModel"
      :selectedClientId="clientId"
      @buttonclick="genericMethodClick"
      @editableRowButtonClick="genericMethodClick"
      @applyChangesNonSuper="applyChangesNonSuper"
      :nonSuperFilterObject="nonSuperFilterObject"
      @onChange="onChange"
      @saveData="resetSuperannuationModel"
      :tableViewSettings="tableViewSettings"
      :showTableView="showTableView"
      v-if="selectedComponent != null"
    >
    </component>
  </div>
</template>

<script>
import { SuperBaseEngagementTool } from "../../component/super";
import { ConfirmationDialog } from "../../component/tool";

import {
  AdvanceSuperFilter,
  AdvanceSuperFilterComponents,
  tableBalanceAreaSuper,
  sgcData,
} from "../../helpers/constant";
import {
  DurationOption,
  GrowthOption,
  PensionOption,
  EntityTypes,
  superClientsMenu,
  DownloadOption,
} from "../../helpers/constant";
import Superannuation from "../../models/superannuation";
import {
  EngagementBasicScreen,
  EngagementChart,
  SuperEngagementTool,
  ICESuperIntegration,
  SuperTool,
  SuperannuationEngagementTool,
  UserEvent,
  ExcelDownload,
} from "../../mixin";

import SuperannuationNonSuperTool from "./superannuation-nonSuper-tool.vue";
import SuperEditPopup from "./super-edit-popup.vue";
import { SuperannuationService } from "../../services";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_ENTITY_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
  SET_NOTIFICATION_SUMMARY,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_RISK_PROFILE_DATA,
  SET_LOADER_VISIBILITY,
  SET_ICE_API_RESPONSE,
  GET_PROJECTION_MODEL,
  SET_ICE_PROJECTION_MODEL,
  GET_SUPERANNUATION_CHART_MODEL,
  GET_AUTH_INFORMATION,
  GET_CLIENT_INFORMATION,
  GET_ICE_API_RESPONSE,
  SET_SUPERANNUATION_CHART_MODEL,
} from "../../helpers/vuex-constants";
import { mapGetters, mapActions } from "vuex";
import SuperAdvanceFilter from "./super-advance-filter.vue";
import {
  SuperSelected,
  UpdateAction,
  AdvaceGraphAction,
  SaveAction,
  DownloadExcelFile,
  DownloadPDFFile,
  DownloadWordFile,
} from "../../helpers/userEvent";
import { CommonHelper } from "../../helpers";
import AdlDataList from "../../component/custom/DataList/DataList.vue";
import _ from "lodash";
import { MdsTable, MdsTr, MdsTd } from "@mds/data-table";

export default {
  components: {
    SuperBaseEngagementTool,
    ConfirmationDialog,
    SuperAdvanceFilter,
    SuperannuationNonSuperTool,
    AdlDataList,
    SuperEditPopup,
    MdsTable,
    MdsTr,
    MdsTd,
  },
  data() {
    return {
      sgcValues: sgcData,
      resetButtonStatus: true,
      userInput: [],
      selectedClientId: 0,
      reportDownloadOption: DownloadOption,
      baselineData: {},
      clientId: 0,
      nonSuperFilterObject: [],
      chartData: [],
      menuId: 0,
      subMenuId: 0,
      selectedComponent: "",
      openTabName: "",
      selectMenu: 0,
      selectedSubMenu: 0,
      refreshKey: 0,
      isopenModel: false,
      projectionModel: {},
      previousPageUrl: "superannuation-instance-selection",
      defaultRetirementAge: 65,
      formslotElement: {},
      initialPojectionYear: 0,
      editSuperKey: 0,
      tableViewSettings: {},
      showTableView: false,
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
    };
  },
  mounted() {
    this.projectionYear.Value = this.selectedSuperannuationData.projectionYear;

    this.clientId = this.selectedSuperannuationData.clientId;
    if (
      this.selectedSuperannuationData.superFundGuid !=
        "00000000-0000-0000-0000-000000000000" ||
      this.selectedSuperannuationData.isNotShowEmptyState
    ) {
      // if( this.$route.params.loadChart == undefined )
      //  {}

      this.reloadSuperGraph();
    } else {
      this.isShowEmptyState = true;
    }

    if (
      this.ClientInformation.length > 0 &&
      this.selectedSuperannuationData.ownerDetails.filter(
        (m) => m.clientId == this.ClientInformation[0].clientId
      )[0] == undefined
    ) {
      this.selectedSuperannuationData.ownerDetails.push({
        clientId: this.ClientInformation[0].clientId,
        retirementAge: this.defaultRetirementAge,
        superBalance: 0,
        totalIncome: 0,
        factTotalIncome: 0,
      });
    }
    if (
      this.PartnerInformation.length > 0 &&
      this.selectedSuperannuationData.ownerDetails.filter(
        (m) => m.clientId == this.PartnerInformation[0].clientId
      )[0] == undefined
    ) {
      let PartnerID = this.PartnerInformation[0].clientId;
      this.selectedSuperannuationData.ownerDetails.push({
        clientId: PartnerID,
        retirementAge: this.defaultRetirementAge,
        superBalance: 0,
        totalIncome: 0,
        factTotalIncome: 0,
      });
    }
    this.formChange(this.formModel);
    this.setAddtionFilterInfoInFormModel();
  },

  async created() {
    this.setChartViewTypeDropDown();
  },

  computed: {
    ClientInformation() {
      return this.getClientInformation.filter(
        (x) => x.entityType == EntityTypes.client
      );
    },
    PartnerInformation() {
      return this.getClientInformation.filter(
        (x) => x.entityType == EntityTypes.partner
      );
    },
    formModel() {
      return {
        tabs: Superannuation.getSuperFundTab(this.clientInfo),
        sections: Superannuation.getSuperFundSection(this.clientInfo),
        sectionElements: Superannuation.getSectionGroupElements(
          this.clientInfo
        ),
        elements: Superannuation.getSuperFundSectionElements(
          this.clientInfo,
          this.selectedSuperannuationData,
          this.getRiskProfileData,
          DurationOption,
          GrowthOption,
          PensionOption
        ),
      };
    },
    formSubmitElements() {
      return Superannuation.getSubmitFormElement(this.resetButtonStatus);
    },
    ExpandableCardData() {
      let selectedData = this.selectedSuperannuationData;
      let defaultData = this.getDefaultExpandableData();
      let currentDate = new Date();
      if (selectedData.ownerDetails.length == 0) {
        this.setdefaultOwnerDetails();
      }
      let ownerDetails = selectedData.ownerDetails;
      let otherDetail = selectedData.otherDetail;
      let superAdvanceDetails = selectedData.superAdvanceDetails;
      let totalNonSuperBalance = {};
      totalNonSuperBalance = selectedData.nonSuperData;
      otherDetail.nonSuperBalance =
        totalNonSuperBalance.length > 0
          ? totalNonSuperBalance[0].currentValue
          : otherDetail.nonSuperBalance;
      let cardlist = this.getClientInformation
        .filter(
          (x) =>
            x.entityType == EntityTypes.partner ||
            x.entityType == EntityTypes.client ||
            x.entityType == EntityTypes.both
        )
        .map((t) => {
          let p = {};
          p.text = t.clientName.replace(/(^MRS|MR|MISS)/gi, "");
          p.value = t.clientId;
          p.entityType = t.entityType;
          return p;
        });
      let defaultClientId = this.getdefaultClientDetails(cardlist);
      let groupFormat = [];
      let Elements = [];
      let index = 0;
      let ElementId = 369;
      groupFormat.push({
        name: "",
        element: [index++],
        class: "",
        ShowOnMinimise: true,
      });
      Elements.push({
        type: "FormField",
        id: ElementId++,
        name: "Super Annuation",
        dataType: "text",
        displayType: "carddropdown",
        htmlName: "superuser",
        key: "superUser",
        label: "",
        title: selectedData.description,
        caption: "",
        imageheight: "45",
        imagewidth: "45",
        imagepath: require(`../../assets/icons/super.svg`),
        options: cardlist,
        value: defaultClientId,

        EditToggle: false,
        validations: [],
        isShowRefreshIcon: true,
        showOnMinimise: true,
      });
      if (this.ClientInformation.length > 0) {
        groupFormat.push({
          name: this.ClientInformation[0].preferedName,
          element: [index++, index++, index++],
          class: "group-section",
          ShowOnMinimise: false,
        });
        let ClientDetail = ownerDetails.filter(
          (x) => x.clientId == this.ClientInformation[0].clientId
        )[0];

        let superAdvanceClientdetails = superAdvanceDetails
          .filter((x) => x.clientId == this.ClientInformation[0].clientId)
          .reduce((a, superAdvance) => a + superAdvance.superFundBalance, 0);
        let RetirementDate = "";
        if (
          ClientDetail &&
          ClientDetail.retirementAge &&
          this.ClientInformation[0].dob
        ) {
          RetirementDate = CommonHelper.getRetirementDate(
            this.ClientInformation[0].dob,
            ClientDetail.retirementAge
          );
        } else if (this.ClientInformation[0].dob) {
          RetirementDate = CommonHelper.getRetirementDate(
            this.ClientInformation[0].dob,
            this.defaultRetirementAge
          );
        }

        Elements.push(
          {
            type: "FormField",
            id: ElementId++,
            name: "Retirement",
            dataType: "text",
            displayType: "editableLabel",
            htmlName: "retirementclient",
            key: "retirementClient",
            step: 0.25,
            options: [],
            EditState: false,
            value: ClientDetail
              ? ClientDetail.retirementAge
              : this.defaultRetirementAge,
            defaultValue: defaultData.client.retirementAge,
            text:
              RetirementDate.toLocaleString("default", { month: "short" }) +
              " " +
              RetirementDate.getFullYear() +
              ", " +
              (ClientDetail
                ? ClientDetail.retirementAge
                : this.defaultRetirementAge) +
              " Y",
            defaultText:
              defaultData.client.RetirementDate.toLocaleString("default", {
                month: "short",
              }) +
              " " +
              defaultData.client.RetirementDate.getFullYear() +
              ", " +
              defaultData.client.retirementAge +
              "Y",
            minValue: 0,
            maxValue: 15.0,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            HasEditButton: true,
            HasTag: ClientDetail ? currentDate >= RetirementDate : false,
            TagText: "Retired",
            EditToggle: RetirementDate != "",
            cancelText: "Cancel",
            saveText: "Save",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 0,
            maxlength: 2,
            maxvalue: 99,
            minvalue: 0,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: true,
          },
          {
            type: "FormField",
            id: ElementId++,
            name: "Superannuation ",
            dataType: "text",
            displayType: "editableLabel",
            key: "superClient",
            htmlName: "superclient",
            EditState: false,
            step: 0.25,
            options: [],
            text: CommonHelper.convertIntoCurrencyWithoutDecimal(
              superAdvanceClientdetails
            ),
            defaultText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              defaultData.client.AdvanceDetailsSum
            ),
            value: superAdvanceClientdetails,
            defaultValue: defaultData.client.AdvanceDetailsSum,
            minValue: 0,
            maxValue: 15.0,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            EditToggle: false,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: false,
            EditEvent: "SuperClient_Click",
            HasEditButton: true,
          },
          {
            type: "FormField",
            id: ElementId++,
            name: "Income",
            dataType: "text",
            displayType: "editableLabel",
            htmlName: "incomeclient",
            key: "incomeClient",
            step: 0.25,
            options: [],
            EditState: false,
            text: CommonHelper.convertIntoCurrencyWithoutDecimal(
              ClientDetail ? ClientDetail.totalIncome : 0
            ),
            defaultText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              defaultData.client.clientIncome
            ),
            refreshValueText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              ClientDetail ? ClientDetail.factTotalIncome : 0
            ),
            refreshValue: ClientDetail ? ClientDetail.factTotalIncome : 0,
            value: ClientDetail ? ClientDetail.totalIncome : 0,
            defaultValue: defaultData.client.clientIncome,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            HasEditButton: true,
            HasTag: false,
            EditToggle: true,
            cancelText: "Cancel",
            saveText: "Save",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 0,
            maxlength: 9,
            maxvalue: 999999999,
            minvalue: 0,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: true,
            currencyFormat: "$,",
            style: "margin-right:30px",
            refreshText: "Use latest balance",
            refreshToolTip: "Import latest employer income from FactFind",
            isShowRefresh:
              this.selectedSuperannuationData.isFromFact &&
              ClientDetail != undefined &&
              ClientDetail.totalIncome !== ClientDetail.factTotalIncome,
          }
        );
      }
      if (this.PartnerInformation.length > 0) {
        groupFormat.push({
          name: this.PartnerInformation[0].preferedName,
          element: [index++, index++, index++],
          class: "group-section",
          ShowOnMinimise: false,
        });
        let PartnerDetail = ownerDetails.filter(
          (x) => x.clientId == this.PartnerInformation[0].clientId
        )[0];
        let superAdvancePartnerdetails = superAdvanceDetails
          .filter((x) => x.clientId == this.PartnerInformation[0].clientId)
          .reduce((a, superAdvance) => a + superAdvance.superFundBalance, 0);

        let RetirementDate = "";
        if (
          PartnerDetail &&
          PartnerDetail.retirementAge &&
          this.PartnerInformation[0].dob
        ) {
          RetirementDate = CommonHelper.getRetirementDate(
            this.PartnerInformation[0].dob,
            PartnerDetail.retirementAge
          );
        } else if (this.PartnerInformation[0].dob) {
          RetirementDate = CommonHelper.getRetirementDate(
            this.PartnerInformation[0].dob,
            this.defaultRetirementAge
          );
        }
        Elements.push(
          {
            type: "FormField",
            id: ElementId++,
            name: "Retirement",
            dataType: "text",
            displayType: "editableLabel",
            htmlName: "retirementpartner",
            key: "retirementPartner",
            EditState: false,
            step: 0.25,
            options: [],
            value: PartnerDetail
              ? PartnerDetail.retirementAge == "0"
                ? this.defaultRetirementAge
                : PartnerDetail.retirementAge
              : this.defaultRetirementAge,
            defaultValue: defaultData.partner.retirementAge,
            text:
              RetirementDate.toLocaleString("default", { month: "short" }) +
              " " +
              RetirementDate.getFullYear() +
              ", " +
              (PartnerDetail
                ? PartnerDetail.retirementAge == "0"
                  ? this.defaultRetirementAge
                  : PartnerDetail.retirementAge
                : this.defaultRetirementAge) +
              " Y",
            defaultText:
              defaultData.partner.RetirementDate.toLocaleString("default", {
                month: "short",
              }) +
              " " +
              defaultData.partner.RetirementDate.getFullYear() +
              ", " +
              defaultData.partner.retirementAge +
              " Y",
            minValue: 0,
            maxValue: 15.0,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            HasEditButton: true,
            HasTag: PartnerDetail ? currentDate >= RetirementDate : false,
            TagText: "Retired",
            EditToggle: RetirementDate != "",
            cancelText: "Cancel",
            saveText: "Save",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 0,
            maxlength: 2,
            maxvalue: 99,
            minvalue: 0,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: true,
          },
          {
            type: "FormField",
            id: ElementId++,
            name: "Superannuation ",
            dataType: "text",
            displayType: "editableLabel",
            htmlName: "superpartner",
            EditState: false,
            key: "superPartner",
            step: 0.25,
            options: [],
            text: CommonHelper.convertIntoCurrencyWithoutDecimal(
              superAdvancePartnerdetails
            ),
            defaultText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              defaultData.partner.AdvanceDetailsSum
            ),
            value: superAdvancePartnerdetails,
            minValue: 0,
            defaultValue: defaultData.partner.AdvanceDetailsSum,
            maxValue: 15.0,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            EditToggle: false,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: false,
            EditEvent: "SuperPartner_Click",
            HasEditButton: true,
          },
          {
            type: "FormField",
            id: ElementId++,
            name: "Income",
            dataType: "text",
            displayType: "editableLabel",
            htmlName: "incomepartner",
            EditState: false,
            key: "incomePartner",
            step: 0.25,
            options: [],
            text: CommonHelper.convertIntoCurrencyWithoutDecimal(
              PartnerDetail ? PartnerDetail.totalIncome : 0
            ),
            defaultText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              defaultData.partner.clientIncome
            ),
            refreshValueText: CommonHelper.convertIntoCurrencyWithoutDecimal(
              PartnerDetail ? PartnerDetail.factTotalIncome : 0
            ),
            refreshValue: PartnerDetail ? PartnerDetail.factTotalIncome : 0,
            value: PartnerDetail ? PartnerDetail.totalIncome : 0,
            defaultValue: defaultData.partner.clientIncome,
            inputMax: 100.0,
            isShowDecimal: true,
            validations: [],
            HasEditButton: true,
            HasTag: false,
            EditToggle: true,
            cancelText: "Cancel",
            saveText: "Save",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 0,
            maxlength: 9,
            maxvalue: 999999999,
            minvalue: 0,
            showOnMinimise: false,
            ShowValue: true,
            ShowEditTextBox: true,
            currencyFormat: "$,",
            style: "margin-right:30px",
            refreshText: "Use latest balance",
            isShowRefresh:
              this.selectedSuperannuationData.isFromFact &&
              PartnerDetail != undefined &&
              PartnerDetail.totalIncome !== PartnerDetail.factTotalIncome,
          }
        );
      }
      groupFormat.push({
        name: "Other Details",
        element: [index++, index++, index++, index],
        class: "group-section",
        ShowOnMinimise: true,
      });
      Elements.push(
        {
          type: "FormField",
          id: ElementId++,
          name: "Age Pension",
          dataType: "text",
          displayType: "radiobutton",
          htmlName: "agepension",
          key: "agePension",
          value: otherDetail ? otherDetail.isAgePension : true,
          defaultValue: defaultData.otherDetails.isAgePension,
          EditToggle: false,
          showOnMinimise: false,
          ShowToolTip: true,
          ShowToolTipText: false,
          TooltipMessage: "Select Age Pension Yes or No",
        },
        {
          type: "FormField",
          id: ElementId++,
          name: "Home Owner",
          dataType: "text",
          displayType: "radiobutton",
          htmlName: "homeowner",
          key: "homeOwner",
          value: otherDetail ? otherDetail.isHomeOwner : true,
          defaultValue: defaultData.otherDetails.isHomeOwner,
          EditToggle: false,
          showOnMinimise: false,
          ShowToolTip: true,
          ShowToolTipText: false,
          TooltipMessage: "Select Home Owner Yes or No",
        },
        {
          type: "FormField",
          id: ElementId++,
          name: "Non Super",
          dataType: "text",
          displayType: "editableLabel",
          EditState: false,
          htmlName: "nonsuper",
          key: "nonSuper",
          step: 0.25,
          options: [],
          text: CommonHelper.convertIntoCurrencyWithoutDecimal(
            otherDetail.nonSuperBalance ? otherDetail.nonSuperBalance : 0
          ),
          value: otherDetail.nonSuperBalance,
          defaultValue: defaultData.otherDetails.nonSuperBalance,
          defaultText: CommonHelper.convertIntoCurrencyWithoutDecimal(
            defaultData.otherDetails.nonSuperBalance
          ),
          minValue: 0,
          maxValue: 15.0,
          inputMax: 100.0,
          isShowDecimal: true,
          validations: [],
          EditToggle: false,
          showOnMinimise: false,
          ShowValue: true,
          ShowEditTextBox: false,
          EditEvent: "NonSuper_Click",
          HasEditButton: true,
          refreshValue: defaultData.otherDetails.factNonSuperBalance,
          refreshValueText: CommonHelper.convertIntoCurrencyWithoutDecimal(
            defaultData.otherDetails.factNonSuperBalance
          ),
          refreshText: "Use latest balance",
          refreshToolTip: "Import latest Nonsuper Balance from FactFind",
          isShowRefresh:
            this.selectedSuperannuationData.isFromFact &&
            defaultData.otherDetails.factNonSuperBalance !==
              otherDetail.nonSuperBalance,
        },
        {
          type: "FormField",
          id: ElementId++,
          name: "Retirement Expense",
          dataType: "text",
          displayType: "slider",
          htmlName: "retirementExpense",
          key: "retirementExpense",
          options: [],
          value: otherDetail ? otherDetail.retirementExpenseBalance : 0,
          step: 100,
          minValue: 0,
          maxValue: 20000,
          inputMax: 999999999,
          validations: [],
          inputFormat: "$,",
          isCurrencyFormat: true,
          EditToggle: false,
          showOnMinimise: true,
          defaultValue: defaultData.otherDetails.retirementExpenseBalance,
          maxlength: 9,
        }
      );

      return {
        type: "Form",
        groupFormat: groupFormat,
        elements: Elements,
        htmlName: "ExpandableCard",
        isResponsive: "true",
        size: {
          type: "Size",
          width: "0",
          height: "0",
        },
      };
    },

    ...mapGetters({
      getRiskProfileData: GET_RISK_PROFILE_DATA,
      getAuthInformation: GET_AUTH_INFORMATION,
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
    ...mapGetters("superannuation", {
      clientInfo: GET_SUPERANNUATION_ENTITY_INFORMATION,
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      advanceScreenSuperannuationChartModel: GET_SUPERANNUATION_CHART_MODEL,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
      getProjectionModel: GET_PROJECTION_MODEL,
      getProjectionApiResponse: GET_ICE_API_RESPONSE,
    }),
  },
  mixins: [
    EngagementBasicScreen,
    EngagementChart,
    SuperEngagementTool,
    ICESuperIntegration,
    SuperTool,
    SuperannuationEngagementTool,
    UserEvent,
    ExcelDownload,
  ],

  methods: {
    onSelectViewTypeFilter(button, data) {
      button.toggle2 = false;
      this.buttonViewTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "View: " + data.itemText.slice(0, -5);
      this.showTableView = data.itemValue == 3;
    },
    onLeave(event) {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      if (isFormChanges >= 0) {
        event.preventDefault();
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page? Unsaved changes will be lost.";
      }
    },
    EditDataList(data) {
      this.clientId = data.clientID;
      if (data.typeId == AdvanceSuperFilter.Accumulation) {
        this.menuId = superClientsMenu[0].id;
        this.subMenuId = superClientsMenu[0].subMenu[0].id;
        this.openTabName = AdvanceSuperFilterComponents.Accumulation;
      } else if (data.typeId == AdvanceSuperFilter.Pension) {
        this.menuId = superClientsMenu[0].id;
        this.openTabName = AdvanceSuperFilterComponents.Pension;
        this.subMenuId = superClientsMenu[0].subMenu[1].id;
      } else if (data.typeId == AdvanceSuperFilter.Contribution) {
        this.menuId = superClientsMenu[1].id;
        this.openTabName = AdvanceSuperFilterComponents.Contribution;
      } else if (data.typeId == AdvanceSuperFilter.WithdrawalAccumulation) {
        this.openTabName = AdvanceSuperFilterComponents.WithdrawalAccumulation;
        this.menuId = superClientsMenu[2].id;
        this.subMenuId = superClientsMenu[2].subMenu[0].id;
      } else if (data.typeId == AdvanceSuperFilter.WithdrawalPension) {
        this.menuId = superClientsMenu[2].id;
        this.subMenuId = superClientsMenu[2].subMenu[1].id;
        this.openTabName = AdvanceSuperFilterComponents.WithdrawalPension;
      } else if (data.typeId == AdvanceSuperFilter.MarketCrash) {
        this.clientId = 0;
        this.menuId = superClientsMenu[3].id;
        this.openTabName = AdvanceSuperFilterComponents.MarketCrash;
      } else if (data.typeId == AdvanceSuperFilter.PensionPayment) {
        this.menuId = superClientsMenu[4].id;
        this.openTabName = AdvanceSuperFilterComponents.PensionPayment;
      } else if (data.typeId == AdvanceSuperFilter.FeeAccumulation) {
        this.openTabName = AdvanceSuperFilterComponents.FeeAccumulation;
        this.menuId = superClientsMenu[5].id;
        this.subMenuId = superClientsMenu[5].subMenu[0].id;
      } else if (data.typeId == AdvanceSuperFilter.FeePension) {
        this.menuId = superClientsMenu[5].id;
        this.subMenuId = superClientsMenu[5].subMenu[1].id;
        this.openTabName = AdvanceSuperFilterComponents.FeePension;
      }

      this.openAdvancedFilter(
        this.menuId,
        this.subMenuId,
        this.clientId,
        this.openTabName
      );
    },
    refresh(data) {
      data.text = data.refreshValueText;
      data.value = data.refreshValue;
      data.isShowRefresh = false;
      if (data.htmlName == "nonsuper") {
        this.selectedSuperannuationData.nonSuperData[0].currentValue =
          data.refreshValue;
      }
    },
    getdefaultClientDetails(cardlist) {
      if (this.selectedClientId > 0) {
        return this.selectedClientId;
      } else {
        let defaultClientId = 0;
        for (let i = 0; i < cardlist.length; i++) {
          if (cardlist[i].entityType == EntityTypes.both) {
            defaultClientId = cardlist[i].value;
          } else if (
            cardlist[i].entityType == EntityTypes.client &&
            defaultClientId == 0
          ) {
            defaultClientId = cardlist[i].value;
          }
        }
        this.selectedClientId = defaultClientId;
        return defaultClientId;
      }
    },
    getDefaultExpandableData() {
      let defaultData = _.cloneDeep(
        this.getSuperannuationInformation.filter(
          (x) =>
            x.superFundId == this.selectedSuperannuationData.superFundId &&
            x.superFundGuid == this.selectedSuperannuationData.superFundGuid
        )[0]
      );
      let ownerDetails = defaultData.ownerDetails;
      let NonSuperSum =
        defaultData.nonSuperData.length > 0
          ? defaultData.nonSuperData[0].currentValue
          : defaultData.otherDetail.nonSuperBalance;
      defaultData.otherDetail.nonSuperBalance = NonSuperSum;
      let defaultRetirementAgeClient = this.defaultRetirementAge;
      let defaultRetirementAgePartner = this.defaultRetirementAge;
      let clientOwnerDetails = ownerDetails.filter(
        (x) => x.clientId == this.ClientInformation[0].clientId
      );
      let partnerOwnerDetails = 0;
      if (this.PartnerInformation.length > 0)
        partnerOwnerDetails = ownerDetails.filter(
          (x) => x.clientId == this.PartnerInformation[0].clientId
        );
      if (ownerDetails.length > 0) {
        if (clientOwnerDetails.length > 0) {
          defaultRetirementAgeClient = clientOwnerDetails[0].retirementAge;
        }
        if (partnerOwnerDetails.length > 0) {
          defaultRetirementAgePartner = partnerOwnerDetails[0].retirementAge;
        }
      }

      let clientIncome =
        clientOwnerDetails.length > 0
          ? ownerDetails.filter(
              (x) => x.clientId == this.ClientInformation[0].clientId
            )[0].totalIncome
          : 0;
      let PartnerIncome =
        partnerOwnerDetails.length > 0
          ? ownerDetails.filter(
              (x) => x.clientId == this.PartnerInformation[0].clientId
            )[0].totalIncome
          : 0;

      let data = {
        client: {
          retirementAge: defaultRetirementAgeClient,
          clientIncome: clientIncome,
          AdvanceDetailsSum: defaultData.superAdvanceDetails
            .filter((x) => x.clientId == this.ClientInformation[0].clientId)
            .reduce((a, superAdvance) => a + superAdvance.superFundBalance, 0),
          RetirementDate: CommonHelper.getRetirementDate(
            this.ClientInformation[0].dob,
            defaultRetirementAgeClient
          ),
          factTotalIncome:
            clientOwnerDetails.length > 0
              ? ownerDetails.filter(
                  (x) => x.clientId == this.ClientInformation[0].clientId
                )[0].factTotalIncome
              : 0,
        },
        partner: {
          retirementAge: defaultRetirementAgePartner,
          clientIncome: PartnerIncome,
          AdvanceDetailsSum:
            this.PartnerInformation.length > 0
              ? defaultData.superAdvanceDetails
                  .filter(
                    (x) => x.clientId == this.PartnerInformation[0].clientId
                  )
                  .reduce(
                    (a, superAdvance) => a + superAdvance.superFundBalance,
                    0
                  )
              : 0,
          RetirementDate:
            this.PartnerInformation.length > 0
              ? CommonHelper.getRetirementDate(
                  this.PartnerInformation[0].dob,
                  defaultRetirementAgePartner
                )
              : 0,
          factTotalIncome:
            partnerOwnerDetails.length > 0
              ? ownerDetails.filter(
                  (x) => x.clientId == this.PartnerInformation[0].clientId
                )[0].factTotalIncome
              : 0,
        },
        otherDetails: defaultData.otherDetail,
      };
      return data;
    },
    editExpandablecard(data, additionalInfo) {
      this.createOtherDetailsModel(this.selectedSuperannuationData);
      this.genericMethodClick(data, additionalInfo);
    },
    setdefaultOwnerDetails() {
      if (
        this.ClientInformation.length > 0 &&
        this.selectedSuperannuationData.ownerDetails.filter(
          (m) => m.clientId == this.ClientInformation[0].clientId
        )[0] == undefined
      ) {
        this.selectedSuperannuationData.ownerDetails.push({
          clientId: this.ClientInformation[0].clientId,
          retirementAge: this.defaultRetirementAge,
          superBalance: 0,
          totalIncome: 0,
          taxableComponent: 0,
          taxFreeComponent: 0,
          factTotalIncome: 0,
        });
      }
      if (
        this.PartnerInformation.length > 0 &&
        this.selectedSuperannuationData.ownerDetails.filter(
          (m) => m.clientId == this.PartnerInformation[0].clientId
        )[0] == undefined
      ) {
        let PartnerID = this.PartnerInformation[0].clientId;
        this.selectedSuperannuationData.ownerDetails.push({
          clientId: PartnerID,
          retirementAge: this.defaultRetirementAge,
          superBalance: 0,
          totalIncome: 0,
          taxableComponent: 0,
          taxFreeComponent: 0,
          factTotalIncome: 0,
        });
      }
    },
    IncomeClient_Click() {},
    SuperClient_Click() {
      this.selectedSuperannuationData.selectClientIdForSuperFundEdit =
        this.getClientInformation.filter((m) => m.entityType == 1)[0].clientId;

      this.selectedComponent = "super-edit-popup";
      this.isopenModel = true;
      // this.$router.push({ name: "edit-super-details" });
    },
    SuperPartner_Click() {
      this.selectedSuperannuationData.selectClientIdForSuperFundEdit =
        this.getClientInformation.filter((m) => m.entityType == 2)[0].clientId;
      // this.$router.push({ name: "edit-super-details" });
      this.selectedComponent = "super-edit-popup";
      this.isopenModel = true;
    },
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("superannuation", {
      setProjectionApiResponse: SET_ICE_API_RESPONSE,
      setSuperannuationChartModel: SET_ICE_PROJECTION_MODEL,
      setSelectedSuperannuationInfo: SET_SELECTED_SUPERANNUATION_INFORMATION,
      setsuperchartModel: SET_SUPERANNUATION_CHART_MODEL,
    }),
    openAdvancedFilter(menuId, submenuId, clientId, pageName) {
      this.isopenModel = false;
      this.selectedComponent = "super-advance-filter";
      this.openTabName = pageName ? pageName : "advance-accumulation";
      this.isopenModel = true;
      this.baselineData.fundDetails = this.getSuperFundModel();
      this.baselineData.superAddtionalDetails = this.createrowModel(
        this.selectedSuperannuationData.superAddtionalDetails
      );
      this.baselineData.riskProfileOption = this.getRiskProfileData.data;

      this.baselineData.projectionYear = this.projectionYear.Value;
      this.baselineData.iceInput = this.getUiBaselineModel();
      this.baselineData.iceApiResponse = {};
      let clienDetails = this.getClientInfo(this.selectedClientId);
      if (clienDetails.length > 0)
        this.baselineData.clientDetail = clienDetails[0];

      this.baselineData.ownerDetails = this.getOwnerDetailsModel();
      this.clientId =
        clientId != undefined
          ? clientId
          : this.selectedSuperannuationData.clientId;
      this.menuId = menuId > 0 ? menuId : superClientsMenu[0].id;
      this.subMenuId =
        submenuId > 0 ? submenuId : superClientsMenu[0].subMenu[0].id;
      this.setsuperchartModel(this.projectionModel);
      this.saveUserSession(SuperSelected, AdvaceGraphAction, "");
    },

    ChangeExpandableCard(data) {
      if (data) {
        this.ExpandableCardData.elements = data.elements;
      }
      if (!this.isShowEmptyState) this.filterGraphDataByOwner();
      this.ExpandableCardData.elements.forEach((element) => {
        if (element.htmlName == "retirementclient") {
          let RetirementDate = CommonHelper.getRetirementDate(
            this.ClientInformation[0].dob,
            element.value
          );
          element.text =
            RetirementDate.toLocaleString("default", { month: "short" }) +
            " " +
            RetirementDate.getFullYear() +
            ", " +
            element.value +
            " Y";
        }
        if (element.htmlName == "retirementpartner") {
          let RetirementDate = CommonHelper.getRetirementDate(
            this.PartnerInformation[0].dob,
            element.value
          );
          element.text =
            RetirementDate.toLocaleString("default", { month: "short" }) +
            " " +
            RetirementDate.getFullYear() +
            ", " +
            element.value +
            " Y";
        }
        if (element.htmlName == "incomeclient") {
          element.text = CommonHelper.convertIntoCurrencyWithoutDecimal(
            element.value
          );
        }
        if (element.htmlName == "incomepartner") {
          element.text = CommonHelper.convertIntoCurrencyWithoutDecimal(
            element.value
          );
        }
        if (element.htmlName == "nonsuper") {
          element.text = CommonHelper.convertIntoCurrencyWithoutDecimal(
            this.selectedSuperannuationData.otherDetail.nonSuperBalance
          );
        }
      });
      this.isSuperFormChanged();
      if (this.ExpandableCardData && this.ExpandableCardData.elements) {
        this.ExpandableCardData.elements.forEach((element) => {
          if (
            ["incomeclient", "incomepartner", "nonsuper"].includes(
              element.htmlName
            )
          ) {
            if (
              this.selectedSuperannuationData.isFromFact &&
              element.value != element.refreshValue
            ) {
              element.isShowRefresh = true;
            } else {
              element.isShowRefresh = false;
            }
          }
        });
      }
    },

    formChange(groupId) {
      this.isopenModel = false;
      this.resetRiskProfileId(groupId);
      this.resetSGCForm(groupId);
      this.isSuperFormChanged();
    },
    isSuperFormChanged() {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      let isExpandableFormChanges = this.ExpandableCardData.elements
        .filter((x) => x.displayType != "carddropdown")
        .findIndex((sr) => sr.defaultValue != sr.value);
      if (isFormChanges >= 0 || isExpandableFormChanges >= 0) {
        this.toggleResetButton(true);
      } else {
        this.toggleResetButton(false);
      }
    },
    // isSuperFormChanged() {
    //   let isFormChanges = this.ExpandableCardData.elements
    //     .filter((x) => x.displayType != "carddropdown")
    //     .findIndex((sr) => sr.defaultValue != sr.value);
    //   if (isFormChanges > 0) {
    //     this.toggleResetButton(true);
    //   } else {
    //     this.toggleResetButton(false);
    //   }
    // },
    getPensionTabLinkId(tabLinkId) {
      let tabId = undefined;
      if (tabLinkId) {
        let index = tabLinkId.lastIndexOf("_");
        if (index >= 0) {
          tabId = tabLinkId.substr(0, index);
        }
      }
      return tabId;
    },

    onChangePension(data, tabLinkId) {
      let totalSectionElements = this.formModel.sectionElements.length;
      let tabId = this.getPensionTabLinkId(tabLinkId);
      for (let i = 0; i < totalSectionElements; i++) {
        if (!tabId || tabId == this.formModel.sectionElements[i].tabLinkId) {
          if (this.formModel.sectionElements[i].type == 2) {
            for (
              let j = 0;
              j < this.formModel.sectionElements[i].groupElement.length;
              j++
            ) {
              let elements =
                this.formModel.sectionElements[i].groupElement[j].uiProp;
              for (let k = 0; k < elements.length; k++) {
                let isdisabled = false;
                let amount = 0;
                if (elements[k].value == "paymentType") {
                  if (
                    this.formModel.elements[elements[k].id].value == 1 ||
                    this.formModel.elements[elements[k].id].value == 3
                  ) {
                    isdisabled = true;
                    amount = 0;
                  } else {
                    amount = 0;
                  }
                  this.setFormProperties(
                    "pensionAmount",
                    isNaN(amount) ? 0 : amount,
                    "value",
                    this.formModel.sectionElements[i].groupElement[j].id
                  );
                  this.setFormProperties(
                    "pensionAmount",
                    isdisabled,
                    "isdisabled",
                    this.formModel.sectionElements[i].groupElement[j].id
                  );
                }
              }
            }
          }
        }
      }
    },

    resetSGCForm(groupId) {
      let isUseSGC = this.getFormProperties("isUseSGC", groupId);
      if (!isUseSGC) {
        this.setFormProperties("contributionAmount", false, "ishide", groupId);

        this.setFormProperties(
          "employerDurationType",
          false,
          "ishide",
          groupId
        );
        this.setFormProperties("employerGrowthType", false, "ishide", groupId);
        this.setFormProperties("isEmployerMax", true, "ishide", groupId);
      } else {
        this.setFormProperties("contributionAmount", true, "ishide", groupId);
        this.setFormProperties("employerDurationType", true, "ishide", groupId);
        this.setFormProperties("contributionAmount", 0, "value", groupId);
        this.setFormProperties("employerGrowthType", true, "ishide", groupId);
        this.setFormProperties("isEmployerMax", true, "ishide", groupId);
      }
    },

    resetRiskProfileId(groupId) {
      let currentIncomeRate = this.getFormProperties("incomeRate", groupId);
      let currentGrowthRate = this.getFormProperties("growthRate", groupId);
      let currentFrankingRate = this.getFormProperties("frankingRate", groupId);
      let riskProfileId = this.getFormProperties("riskProfile", groupId);

      let currentRiskProfile = this.getRiskProfileData.data.filter(
        (sr) => sr.value == riskProfileId
      );
      if (
        currentRiskProfile.length > 0 &&
        (currentRiskProfile[0].incomeRate != currentIncomeRate ||
          currentRiskProfile[0].growthRate != currentGrowthRate ||
          currentRiskProfile[0].frankingRate != currentFrankingRate)
      ) {
        this.setFormProperties("riskProfile", 0, "value", groupId);
      }
    },
    onChangeRiskProfile(data, groupId) {
      this.setFormProperties("riskProfile", data.value, "value", groupId);
      this.setFormProperties(
        "frankingRate",
        data.frankingRate,
        "value",
        groupId
      );
      this.setFormProperties("growthRate", data.growthRate, "value", groupId);
      this.setFormProperties("incomeRate", data.incomeRate, "value", groupId);
    },
    setFormProperties(key, value, fieldName, groupId) {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == key && sr.groupId == groupId
      );
      if (elementIndex >= 0) {
        this.formModel.elements[elementIndex][fieldName] = value;
      }
    },
    getFormProperties(key, groupId) {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) =>
          sr.htmlName == key && (sr.groupId == groupId || sr.groupId == "")
      );
      if (elementIndex >= 0) {
        return this.formModel.elements[elementIndex]["value"];
      }
    },
    NonSuper_Click() {
      ///   this.createOtherDetailsModel();
      let nonSuperData = CommonHelper.createrowModel(
        this.selectedSuperannuationData.nonSuperData
      );

      if ((nonSuperData != null) & (nonSuperData.length == 0)) {
        let riskprofiles = this.getClientRiskProfile();
        nonSuperData = CommonHelper.GetNonSuperDefaultRiskProfileModel(
          riskprofiles,
          this.selectedSuperannuationData.otherDetail
            ? this.selectedSuperannuationData.otherDetail.nonSuperBalance
            : 0
        );
        // let income = riskprofiles.income;
        // let growth = riskprofiles.growth;

        // nonSuperData.push({
        //   currentValue: {
        //     value: this.selectedSuperannuationData.otherDetail.nonSuperBalance,
        //   },
        //   incomeReturn: { value: income },
        //   growthReturn: { value: growth },
        //   contribution: { value: 0 },
        //   nonSuperType: { value: 1 },
        // });
      }
      this.selectedSuperannuationData.nonSuperData =
        CommonHelper.ConvertObjectIntoApiModel(nonSuperData);
      this.nonSuperFilterObject = nonSuperData;
      this.selectedComponent = "superannuation-nonSuper-tool";
      this.isopenModel = true;
    },

    cancelInstance() {
      this.confirmationDialogList[2].toggle = true;
    },
    saveInstance() {
      if (
        this.selectedSuperannuationData.superFundGuid ==
        "00000000-0000-0000-0000-000000000000"
      ) {
        this.saveButtonDialogSaveAs_Click();
      } else {
        this.confirmationDialogList[1].toggle = true;
      }
    },
    onBack() {
      let isformChange = this.checkResetButtonStatus();
      if (!isformChange) {
        this.$router.push({ name: this.previousPageUrl });
      }
    },
    checkResetButtonStatus() {
      if (this.resetButtonStatus) {
        return false;
      } else {
        this.confirmationDialogList[0].toggle = true;
        return true;
      }
    },
    backButtonDialogDiscard_Click() {
      this.$router.push({ name: "superannuation-instance-selection" });
    },
    cancelButtonDialogDiscard_Click() {
      this.$router.push({ name: "engagement-tool-selection" });
    },
    backButtonDialogCancel_Click() {},
    backButtonDialogSave_Click() {
      this.confirmationDialogList.forEach((item) => {
        item.toggle = false;
      });
      this.confirmationDialogList[1].toggle = true;
    },
    saveButtonDialogCancel_Click() {},

    resetAPiModel(modelToUpdate) {
      modelToUpdate.projectionYear = this.projectionYear.Value;
      modelToUpdate.fundDetails = this.getSuperFundModel();
      modelToUpdate.createdBy = this.getAuthInformation.adviserId;
      this.createOtherDetailsModel(modelToUpdate);
      return modelToUpdate;
      //this.createSuperAdditionalDetailsModel();
    },
    getSuperFundModel() {
      let fundDetails = Superannuation.resetFundDetails(
        this.formModel.elements,
        this.formModel.sectionElements
      );
      return fundDetails;
    },

    async saveButtonDialogSave_Click() {
      this.resetAPiModel(this.selectedSuperannuationData);
      let isUpdate = 0;
      await this.reloadSuperGraph();
      this.setLoaderVisibility(true);
      let resetButtomIndex = this.formSubmitElements.findIndex(
        (sr) => sr.variation == "secondary"
      );
      if (this.formSubmitElements[resetButtomIndex].isdisabled) {
        isUpdate = 0;
      } else {
        isUpdate = 1;
      }
      if (this.selectedSuperannuationData.superAdvanceDetails) {
        this.selectedSuperannuationData.superAdvanceDetails.forEach(
          (m) => delete m.lastModifiedDate
        );
      }

      var apiResponse =
        await SuperannuationService.saveSuperannuationInformation(
          this.selectedSuperannuationData,
          this.getProjectionApiResponse
        );
      this.saveUserSession(SuperSelected, SaveAction, "");
      this.setLoaderVisibility(false);
      this.saveEngagementData(
        apiResponse,
        isUpdate == 0
          ? `Superannuation instance ${this.selectedSuperannuationData.superannuationName} has been added.`
          : `Superannuation instance ${this.selectedSuperannuationData.superannuationName} has been updated.`,
        this.previousPageUrl
      );
    },
    isChangeInModel(selectedSuperannuationData) {
      // let superData = _.cloneDeep(this.selectedSuperannuationData)
      // delete superData.initialSuperData

      // let initialData = _.cloneDeep(this.selectedSuperannuationData.initialSuperData)
      // if(initialData)
      // delete initialData.initialSuperData

      if (_.isEqual(this.initialSuperData, selectedSuperannuationData)) {
        return false;
      } else {
        return true;
      }
    },
    async saveButtonDialogSaveAs_Click() {
      this.resetAPiModel(this.selectedSuperannuationData);

      await this.reloadSuperGraph();
      this.setSelectedSuperannuationInfo(this.selectedSuperannuationData);
      this.setSuperannuationChartModel(this.projectionModel);
      this.$router.push({ name: "save-superannuation-engagement-tool" });
    },
    toggleResetButton(isFormChanges) {
      let resetButtomIndex = this.formSubmitElements.findIndex(
        (sr) => sr.variation == "secondary"
      );
      if (resetButtomIndex >= 0) {
        if (isFormChanges) {
          this.formSubmitElements[resetButtomIndex].isdisabled = false;
          this.resetButtonStatus = false;
        } else {
          this.formSubmitElements[resetButtomIndex].isdisabled = true;
          this.resetButtonStatus = true;
        }
      }
    },
    enableNonSuperResetButton(isFormChanges, key) {
      if (this.gridButtonTemplatedata) {
        let resetButtomIndex = this.gridButtonTemplatedata.findIndex(
          (sr) => sr.key == key
        );
        if (resetButtomIndex >= 0) {
          this.gridButtonTemplatedata[resetButtomIndex].isdisabled =
            isFormChanges;
        }
      }
    },

    closeModel() {
      this.isopenModel = false;
      this.selectedComponent = "";
      this.createOtherDetailsModel(this.selectedSuperannuationData);
      this.setSuperannuationChartModel({});
      //this.reloadSuperGraph();
    },
    applyChangesNonSuper(row) {
      this.isopenModel = false;
      this.selectedComponent = "";
      this.selectedSuperannuationData.nonSuperData =
        CommonHelper.ConvertObjectIntoApiModel(row);
      this.ChangeExpandableCard();
    },
    closeEditSuper() {
      this.selectedComponent = "";
      this.isopenModel = false;
      this.editSuperKey++;
    },
    getUiBaselineModel() {
      return {
        otherDetail: this.getOtherDetailsModel(),
        ownerDetails: this.getOwnerDetailsModel(),
        fundDetails: this.getSuperFundModel(),
        nonSuperData: this.getNonsuperData(),
        superfundDetails: this.selectedSuperannuationData.superAdvanceDetails,
        referenceGuid: CommonHelper.uuidv4(),
        superAddtionalDetails:
          this.selectedSuperannuationData.superAddtionalDetails,
      };
    },
    getNonsuperData() {
      let otherDetails = this.getOtherDetailsModel();
      let nonsuperData = [];
      if (
        this.selectedSuperannuationData.nonSuperData &&
        this.selectedSuperannuationData.nonSuperData.length > 0
      ) {
        return this.selectedSuperannuationData.nonSuperData;
      } else {
        let riskprofile = this.getClientRiskProfile();
        nonsuperData.push({
          currentValue: otherDetails.nonSuperBalance,
          incomeReturn: riskprofile.income,
          growthReturn: riskprofile.growth,
          contribution: 0,
        });
        return nonsuperData;
      }
    },
    getClientRiskProfile() {
      let riskprofiles = this.getRiskProfileData.defaultriskprofiles;

      return CommonHelper.getClientRiskProfileModel(
        riskprofiles,
        this.ClientInformation[0].clientId
      );
      // let income = RiskProfile.getRiskProfileValue(
      //   riskprofiles,
      //   this.ClientInformation[0].clientId,
      //   6,
      //   6,
      //   "incomeRate"
      // );
      // let growth = RiskProfile.getRiskProfileValue(
      //   riskprofiles,
      //   this.ClientInformation[0].clientId,
      //   6,
      //   6,
      //   "growthRate"
      // );
      // return { income: income, growth: growth };
    },
    async reloadSuperGraph() {
      let selectedSuperannuationDataCopy = this.resetAPiModel(
        _.cloneDeep(this.selectedSuperannuationData)
      );
      if (
        this.isChangeInModel(selectedSuperannuationDataCopy) ||
        this.initialPojectionYear !== this.projectionYear.Value ||
        this.initialSuperData == undefined
      ) {
        this.chartData = {};
        if (!this.validationsProjectionYear()) {
          return false;
        }
        let baselineData = this.getUiBaselineModel(false);
        this.userInput = [];
        this.userInput.push(baselineData);
        this.selectedSuperannuationData.projectionYear =
          this.projectionYear.Value;
        let apiResponse = await this.getProjectionDataFromIce(
          this.selectedSuperannuationData.s3FilePath,
          this.userInput
        );

        this.selectedSuperannuationData.s3FilePath = "";
        this.isShowEmptyState = false;
        this.setProjectionApiResponse(apiResponse);
        this.filterGraphDataByOwner();

        selectedSuperannuationDataCopy = this.resetAPiModel(
          _.cloneDeep(this.selectedSuperannuationData)
        );
        this.initialSuperData = _.cloneDeep(selectedSuperannuationDataCopy);
        this.initialPojectionYear = this.projectionYear.Value;
        this.projectionData.ageResults = apiResponse.ageResults;
        this.setTableElements();
        this.saveUserSession(SuperSelected, UpdateAction, "");
      }
    },
    setTableElements() {
      let i = 0;
      let ageResult = this.projectionData.ageResults;
      if (this.projectionData.superProjectionResult) {
        let data =
          this.projectionData.superProjectionResult[0].superProjection.map(
            (r) => {
              let p = r;
              p.headeryearage = ageResult
                ? ageResult[i].date +
                  "|" +
                  (ageResult[i].ageClient +
                    (ageResult[i].age_Partner
                      ? "/" + ageResult[i].age_Partner
                      : ""))
                : "";
              p.age =
                this.projectionData.incomeExpense[0].superProjection[i].age;
              p.headeryearage2 = p.year + "|" + p.age;
              i++;
              return p;
            }
          );
        let tableData = this.mapTableView(
          ageResult ? "headeryearage" : "headeryearage2",
          tableBalanceAreaSuper,
          data,
          "Year|Age"
        );
        this.tableViewSettings = tableData;
        console.log(this.tableViewSettings);
      }
    },
    refreshSuperGraphByOwner(
      clientDetail,
      iceAPiResponse,
      isShowEmptyState,
      userInput
    ) {
      this.projectionModel = this.getSuperChartModel(
        clientDetail,
        iceAPiResponse,
        isShowEmptyState,
        userInput
      );
      this.RemapSuperGraphsModel();
    },

    getClientInfo(clientId) {
      return this.getClientInformation.filter((sr) => sr.clientId == clientId);
    },
    filterGraphDataByOwner() {
      let clientId = 0;
      for (let i = 0; i < this.ExpandableCardData.elements.length; i++) {
        const element = this.ExpandableCardData.elements[i];
        if (element.htmlName == "superuser") {
          clientId = element.value;
          break;
        }
      }
      if (clientId > 0) {
        const selectedClient = this.getClientInfo(clientId);
        if (selectedClient.length > 0) {
          this.selectedClientId = selectedClient[0].clientId;
          this.refreshSuperGraphByOwner(
            selectedClient[0],
            this.getProjectionApiResponse,
            this.isShowEmptyState,
            this.userInput
          );
        }
      }
      this.setTableElements();
    },

    createOtherDetailsModel(modelToUpdate) {
      let otherDetail = this.getOtherDetailsModel();
      let ownerDetails = this.getOwnerDetailsModel();

      modelToUpdate.ownerDetails = ownerDetails;
      modelToUpdate.otherDetail = otherDetail;
    },
    getOtherDetailsModel() {
      let otherDetail = {};
      otherDetail.isAgePension = this.ExpandableCardData.elements.filter(
        (x) => x.htmlName == "agepension"
      )[0].value;
      otherDetail.isHomeOwner = this.ExpandableCardData.elements.filter(
        (x) => x.htmlName == "homeowner"
      )[0].value;
      otherDetail.nonSuperBalance = this.ExpandableCardData.elements.filter(
        (x) => x.htmlName == "nonsuper"
      )[0].value;
      otherDetail.retirementExpenseBalance =
        this.ExpandableCardData.elements.filter(
          (x) => x.htmlName == "retirementExpense"
        )[0].value;

      return otherDetail;
    },
    getOwnerDetailsModel() {
      let ownerDetails = [];
      if (this.ClientInformation.length > 0) {
        let clientID = this.ClientInformation[0].clientId;

        ownerDetails.push({
          clientId: clientID,
          retirementAge: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "retirementclient"
          )[0].value,
          superBalance: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "superclient"
          )[0].value,
          totalIncome: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "incomeclient"
          )[0].value,
          factTotalIncome: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "incomeclient"
          )[0].refreshValue,
        });
      }
      if (this.PartnerInformation.length > 0) {
        let PartnerID = this.PartnerInformation[0].clientId;
        ownerDetails.push({
          clientId: PartnerID,
          retirementAge: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "retirementpartner"
          )[0].value,
          superBalance: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "superpartner"
          )[0].value,
          totalIncome: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "incomepartner"
          )[0].value,
          factTotalIncome: this.ExpandableCardData.elements.filter(
            (x) => x.htmlName == "incomepartner"
          )[0].refreshValue,
        });
      }
      return ownerDetails;
    },
    onReset() {
      let totalSuperFormElement = this.formModel.elements.length;
      for (let i = 0; i < totalSuperFormElement; i++) {
        this.formModel.elements[i].value =
          this.formModel.elements[i].defaultValue;
        if (this.formModel.elements[i].htmlName == "isUseSGC") {
          this.resetSGCForm(this.formModel.elements[i].groupId);
        }
      }
      this.resetExpandableCard();
      this.onChangePension();
    },

    resetExpandableCard() {
      const selectedInstance = _.cloneDeep(
        this.getSuperannuationInformation.filter(
          (x) =>
            x.superFundId == this.selectedSuperannuationData.superFundId &&
            x.superFundGuid == this.selectedSuperannuationData.superFundGuid
        )[0]
      );
      this.selectedSuperannuationData.nonSuperData =
        selectedInstance.nonSuperData;
      this.selectedSuperannuationData.superAdvanceDetails =
        selectedInstance.superAdvanceDetails;
      this.selectedSuperannuationData = selectedInstance;

      let data = this.ExpandableCardData;
      data.elements.forEach((element) => {
        if (element.displayType != "carddropdown") {
          element.value = element.defaultValue;
          if (Object.keys(element).includes("defaultText"))
            element.text = element.defaultText;
        }
      });
      this.isSuperFormChanged();
    },
    editableRowButtonClick(callBackMethod, data, rowindex) {
      this.$emit("editableRowButtonClick", callBackMethod, data, rowindex);
    },

    getvalue(data) {
      if (data == undefined) return 0;
      else return data.value;
    },
    resetSuperannuationModel(baselineModel) {
      Superannuation.resetSuperAccumulationDetails(
        baselineModel.fundDetails,
        this.formModel.elements,
        this.formModel.sectionElements
      );
      this.setFormProperties("growthRate", baselineModel.growthRate, "value");
      this.setFormProperties("incomeRate", baselineModel.incomeRate, "value");
      this.setFormProperties(
        "contributionAmount",
        baselineModel.contributionAmount,
        "value"
      );
      this.setFormProperties(
        "durationType",
        baselineModel.durationTypeId,
        "value"
      );
      this.selectedSuperannuationData.superAddtionalDetails =
        baselineModel.superAddtionalDetails;
      this.resetRiskProfileId();
      this.isShowEmptyState = false;
      this.setAddtionFilterInfoInFormModel();
      this.isShowEmptyState = false;

      this.reloadSuperGraph();
      this.closeModel();
    },

    AdvancedFilterData(advanceFilterSetting) {
      if (!advanceFilterSetting || advanceFilterSetting.length == 0) {
        return [];
      }
      let advancedata = advanceFilterSetting.map((r) => {
        let p = {
          label: null,
          data: [],
          clientID: r.clientID,
          superTypeId: r.superTypeId,
          typeId: r.typeId,
        };

        let startMonth =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.startDate)
              );
        let startYear =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getYearfromMonthYear(r.startDate);
        let endMonth =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.endDate)
              );
        let endYear =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getYearfromMonthYear(r.endDate);

        if (
          r.description != undefined &&
          r.description != null &&
          r.description != ""
        ) {
          p.label = r.description;
        } else {
          p.label = this.DescriptionAdditionalForm(
            r.descriptionplaceholder,
            r.typeId
          );
        }
        if (r.typeId == 1 || r.typeId == 2) {
          p.data[0] = `Income ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount1
          )}% Growth  ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount2
          )}% Franking ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount3
          )}%`;
        } else if (
          r.typeId == 3 ||
          r.typeId == 4 ||
          r.typeId == 5 ||
          r.typeId == 6 ||
          r.typeId == 7 ||
          r.typeId == 8 ||
          r.typeId == 9
        ) {
          if (r.typeId == 6) {
            p.data[0] = r.amount1 + "%";
          } else
            p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
              r.amount1
            )}`;
          if (r.typeId == 8 || r.typeId == 9) {
            if (r.option1 - 0 == 1 || r.option1 - 0 == 3)
              p.data[0] = r.amount1 + "%";
            else
              p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
                r.amount2
              )}`;
          }
        }

        p.data[1] = `${startMonth}
            ${startYear} ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;
        return p;
      });
      return advancedata;
    },

    setAddtionFilterInfoInFormModel() {
      let additionalFilter = this.AdvancedFilterData(
        this.selectedSuperannuationData.superAddtionalDetails
      );

      // let clientId = this.ClientInformation[0].clientId;
      // let partnerID = 0;
      // if (this.PartnerInformation.length > 0)
      //   partnerID = this.PartnerInformation[0].clientId;

      if (additionalFilter && additionalFilter.length > 0) {
        this.clientInfo.forEach((element) => {
          this.setFormProperties(
            "AdditionalFieldAccumulation" + element.value,
            additionalFilter.filter(
              (sr) =>
                (sr.typeId == AdvanceSuperFilter.Accumulation ||
                  sr.typeId == AdvanceSuperFilter.WithdrawalAccumulation ||
                  sr.typeId == AdvanceSuperFilter.FeeAccumulation) &&
                sr.clientID == element.value
            ),
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldContribution" + element.value,
            additionalFilter.filter(
              (sr) =>
                sr.typeId == AdvanceSuperFilter.Contribution &&
                sr.clientID == element.value
            ),
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldPensionReturn" + element.value,
            additionalFilter.filter(
              (sr) =>
                sr.typeId == AdvanceSuperFilter.Pension &&
                sr.clientID == element.value
            ),
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldPensionPayment" + element.value,
            additionalFilter.filter(
              (sr) =>
                (sr.typeId == AdvanceSuperFilter.WithdrawalPension ||
                  sr.typeId == AdvanceSuperFilter.PensionPayment ||
                  sr.typeId == AdvanceSuperFilter.FeePension) &&
                sr.clientID == element.value
            ),
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldMarketCrash",
            additionalFilter.filter(
              (sr) => sr.typeId == AdvanceSuperFilter.MarketCrash
            ),
            "options",
            ""
          );
          this.formslotElement =
            this.formModel.elements[this.formModel.elements.length - 1];
        });
      } else {
        this.clientInfo.forEach((element) => {
          this.setFormProperties(
            "AdditionalFieldAccumulation" + element.value,
            [],
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldContribution" + element.value,
            [],
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldPensionReturn" + element.value,
            [],
            "options",
            ""
          );

          this.setFormProperties(
            "AdditionalFieldPensionPayment" + element.value,
            [],
            "options",
            ""
          );
          this.setFormProperties(
            "AdditionalFieldMarketCrash",
            [],
            "options",
            ""
          );
        });
      }
    },
    onChange(ind) {
      this.$emit("onChange", ind);
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    getProjectionData(superProjectionData, incomeProjection) {
      if (incomeProjection && incomeProjection.length > 0) {
        for (let i = 0; i < incomeProjection.length; i++) {
          superProjectionData[i].inflow = incomeProjection[i].inflow;
          superProjectionData[i].outflow = -incomeProjection[i].totalExpense;
        }
      }
      return superProjectionData;
    },
    async downloadExcelFile() {
      this.saveUserSession(SuperSelected, DownloadExcelFile, "");
      let fileName = this.selectedSuperannuationData.description;
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }
      let obj = Object.assign({}, this.projectionData);
      let payload = {
        superAccumulationResult: [],
      };
      payload.superAccumulationResult.push({
        superProjection: this.getProjectionData(
          obj.superProjectionResult[0].superProjection,
          obj.incomeExpense && obj.incomeExpense.length > 0
            ? obj.incomeExpense[0].superProjection
            : []
        ),
      });
      this.getExcelFileStream(payload, fileName);
    },
    getfileName() {
      let fileName = this.selectedSuperannuationData.description;
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }
      return fileName;
    },
    getRiskProfileName(riskProfileId) {
      let currentRiskProfile = this.getRiskProfileData.data.filter(
        (sr) => sr.value == riskProfileId
      );
      if (currentRiskProfile && currentRiskProfile.length > 0) {
        return currentRiskProfile[0].text;
      }
      return "";
    },
    async downloadReport(flag) {
      if (flag == DownloadOption[0].value) {
        this.downloadExcelFile();
      } else if (flag == DownloadOption[1].value) {
        this.saveUserSession(SuperSelected, DownloadPDFFile, "");
        this.downloadPDFFile(0);
      } else {
        this.saveUserSession(SuperSelected, DownloadWordFile, "");
        this.downloadPDFFile(1);
      }
    },
    addRiskProfileName(superModel) {
      if (superModel.fundDetails) {
        for (let i = 0; i < superModel.fundDetails.length; i++) {
          if (superModel.fundDetails[i].riskProfileId >= 0) {
            superModel.fundDetails[i].riskProfileName = this.getRiskProfileName(
              superModel.fundDetails[i].riskProfileId
            );
          }
        }
        for (let i = 0; i < superModel.superAddtionalDetails.length; i++) {
          if (superModel.superAddtionalDetails[i].riskProfile >= 0) {
            superModel.superAddtionalDetails[i].riskProfileName =
              this.getRiskProfileName(
                superModel.superAddtionalDetails[i].riskProfile
              );
          }
        }
      }
    },
    async downloadPDFFile(flag) {
      let payload = this.getSuperProjectionData();

      payload.super = Object.assign({}, this.selectedSuperannuationData);
      payload.super = this.resetAPiModel(payload.super);
      this.addRiskProfileName(payload.super);
      this.getPDFFileStream(
        flag,
        this.getfileName(),
        this.selectedClientId,
        JSON.stringify({
          super: payload.super,
          superAccumulationResult: payload.superAccumulationResult,
        })
      );
    },
    getSuperProjectionData() {
      let obj = Object.assign({}, this.projectionData);
      let payload = {
        superAccumulationResult: [],
      };
      payload.superAccumulationResult.push({
        superProjection: this.getProjectionData(
          obj.superProjectionResult[0].superProjection,
          obj.incomeExpense && obj.incomeExpense.length > 0
            ? obj.incomeExpense[0].superProjection
            : []
        ),
      });
      return payload;
    },
  },
};
</script>

<style lang="scss" module>
.innerlabel input {
  width: 80px !important;
}
</style>
